import { render, staticRenderFns } from "./CaixaContexto.vue?vue&type=template&id=141a7304"
import script from "./CaixaContexto.vue?vue&type=script&lang=js"
export * from "./CaixaContexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports